import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);
const STORAGE_KEY = "alkeon_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      const parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) 
        ? parsed.filter((i) => i && (typeof i.id === "string" || typeof i.id === "number") && i.qty > 0) 
        : [];
    } catch {
      return [];
    }
  });
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (productId, finish = "Ancient Sand", qty = 1) => {
    setItems((prev) => {
      const found = prev.find((i) => i.id === productId && i.finish === finish);
      if (found) {
        return prev.map((i) => 
          i.id === productId && i.finish === finish 
            ? { ...i, qty: Math.min(10, i.qty + qty) } 
            : i
        );
      }
      return [...prev, { id: productId, finish, qty }];
    });
    setIsOpen(true);
  };

  const setQty = (productId, finish, qty) =>
    setItems((prev) => 
      qty <= 0 
        ? prev.filter((i) => !(i.id === productId && i.finish === finish)) 
        : prev.map((i) => 
            i.id === productId && i.finish === finish 
              ? { ...i, qty: Math.min(10, qty) } 
              : i
          )
    );

  const remove = (productId, finish) => 
    setItems((prev) => prev.filter((i) => !(i.id === productId && i.finish === finish)));

  const clear = () => setItems([]);
  const count = items.reduce((s, i) => s + i.qty, 0);

  return (
    <CartContext.Provider value={{ items, add, setQty, remove, clear, count, isOpen, openCart: () => setIsOpen(true), closeCart: () => setIsOpen(false) }}>
      {children}
    </CartContext.Provider>
  );
};